export default __webpack_public_path__ + "static/media/t9.min.4bc56aa9.png";